import {createSlice} from "@reduxjs/toolkit";

const SLICE_NAME = 'newLecturer';

const initialState = {
    data: {},
    nodeId: null
};

const slice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers:{
        setNodeId(state, action) {
            state.nodeId = action.payload;
        },
        setData(state, action) {
            state.data = action.payload;
        }
    }
})

export const { reducer } = slice;

export const {setData, setNodeId} = slice.actions;

export const selectNodeId = state => state[SLICE_NAME].nodeId;
export const selectData = state => state[SLICE_NAME].data;

const newLecturer = reducer;
export default newLecturer;